const dateConstants = {
    QUERY_DATE_FORMAT: 'YYYY-MM-DDTHH:mm:ssZ',
    BACKEND_DATE_FORMAT: 'YYYY-MM-DDTHH:mm:ssZ',
    DATE_DISPLAY_FORMAT: 'D.M.YYYY',
}

export default dateConstants
